import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// RM/SFG weights: always 1 decimal, no thousand separator (5000 → "5000.0").
export const fmtKg = (v) =>
  v === null || v === undefined || v === "" || Number.isNaN(Number(v)) ? "—" : Number(v).toFixed(1);

// FG keeps its existing display; RM/SFG use fmtKg.
export const fmtCoilKg = (kind, v) => (kind === "fg" ? (v?.toLocaleString?.() ?? v ?? "—") : fmtKg(v));

// Slitting tolerance (mm), signed with 2 decimals; legacy lines default to -0.1.
export const fmtTol = (v) => {
  const n = Number(v ?? -0.1);
  return `${n > 0 ? "+" : ""}${n.toFixed(2)}`;
};
